import { AskCancelInput, AskCancelOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

const askCancellation = (input: AskCancelInput) =>
  passengerApi.post<AskCancelInput, AskCancelOutput>('/trip/v1/ask-cancellation', input);

export const useAskCancellation = (tripKey: string) => {
  const askCancellationMutation = useMutation<AskCancelOutput, APIError, AskCancelInput>({
    mutationKey: mutationKeys.user.askCancellation(tripKey),
    mutationFn: () => askCancellation({ key: tripKey }),
  });

  return askCancellationMutation;
};
